import { useAuthStore } from "./authStore";

export const useAuth = () => useAuthStore();
